import React, { useCallback, useState } from 'react';
import { Switch } from 'antd';
import { connect } from 'react-redux';

import { tableColumn } from 'utils';
import { TableList, ActionButton, PropValue } from 'components/common';
import PriceTypeValue from '../PriceTypeValue';


const PriceTypeList = ({ router, columnList, defaultFilter, activeFilter, topActions, actions, priceType }) => {
  const defaultColumnList = ['name', 'is_active', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const [itemIdForUpdate, setItemIdForUpdate] = useState(null);
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    name: tableColumn('Название', 'name', {
      render: (val, item) => (
        <div>
          <PriceTypeValue detail={item} asLink={true} isBack={true} />
          <PropValue label="EXT_ID" value={item.ext_id}/>
        </div>
      ),
      sorter: true,
    }),
    is_active: tableColumn('Активен', 'is_active', {
      sorter: true,
      width: 150,
      render: (val, item) => (
        <div>
          <Switch
            style={{ marginTop: '5px', minWidth: '62px' }}
            checkedChildren="вкл"
            unCheckedChildren="выкл"
            checked={item.is_active}
            loading={priceType.updateStatus.isLoading && itemIdForUpdate === item.id}
            onClick={() => onPriceTypeOnOff(item)}
          />
        </div>
      ),
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton detail={item} modelActions={actions.priceType} actions={[{ name: 'edit' }, { name: 'delete' }]} />
      ),
    }),
  };

  const [selected, setSelected] = useState([]);

  const onLoad = useCallback(
    ({ query, activeFilter }) => {
      if (activeFilter === undefined) {
        activeFilter = priceType.filter.activeFilter;
      }
      actions.priceType.listLoad({ query, activeFilter, locationChange: true });
      setSelected([]);
    },
    [priceType, actions, setSelected],
  );

  const onPriceTypeOnOff = (item) => {
    const data = {
      id: item.id,
      is_active: !item.is_active,
      preventLoadDetail: true,
    };
    setItemIdForUpdate(item.id);
    actions.priceType.update(data);
  };

  const batchDelete = (selected) => {
    actions.priceType.batchDelete({ selected });
  };

  return (
    <TableList
      location={router.location}
      model={priceType}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={topActions}
      showSearch={true}
      selected={selected}
      rowSelection={{
        selectedRowKeys: selected,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelected(selectedRowKeys.slice());
        },
      }}
      rowActions={[
        {
          title: 'Удалить',
          icon: 'delete',
          action: (selected) => batchDelete(selected),
        },
      ]}
      filterFields={{
        list: ['is_active'],
        byName: {
          is_active: {
            label: 'Активно',
            type: 'bool',
          },
        },
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  priceType: state.priceType,
});

const mapDispatch = (dispatch) => ({
  actions: {
    priceType: dispatch.priceType,
  },
});

export default connect(mapState, mapDispatch)(PriceTypeList);
